module.exports = __webpack_public_path__ + "fonts/Sailec-Medium.8e3c9505.ttf";